import Empty from 'components/Empty';
import Spin from 'components/Spin';
import cashierActions from 'features/cashier/services/actions';
import cashierSelectors from 'features/cashier/services/selectors';
import { useMemo, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import { IPackageProgramItem, IPackageProgramTier } from 'services/shop/types/package-program';
import { useAppDispatch } from 'store/hooks';
import PackageProgramChips from './package-program-chips';
import PackageProgramHeader from './package-program-header';
import PackageTierCard from './package-tier-card';
import { sortPackageTiers } from './package-tier-helpers';
import { getPackageThemeByType } from 'features/cashier/services/package-theme';
import { isPackageTierOnTicket } from 'features/cashier/services/package-ticket-item';
import { TierGrid } from './package-tier-card-styles';
import { PackagesPanel } from './styles';

// Panel giữa khi chọn tab Packages: chip program -> thông tin program -> tối đa 3 tier card
const ActivePackages = () => {
  const dispatch = useAppDispatch();
  const programs = shopSelectors.data.packagePrograms() || [];
  const loading = shopSelectors.loading.packagePrograms();
  const customer = cashierSelectors.getSelectedCustomer();
  const selectedItems = cashierSelectors.getSelectedItems();
  const [selectedProgramId, setSelectedProgramId] = useState<string>();

  // program đang chọn không còn trong list (list vừa load / thay đổi) thì quay về program đầu tiên
  const selectedProgram = useMemo(
    () => programs.find((program) => program.id === selectedProgramId) || programs[0],
    [programs, selectedProgramId],
  );
  const tiers = useMemo(() => sortPackageTiers(selectedProgram?.tiers), [selectedProgram]);

  const handleAddToTicket = (program: IPackageProgramItem, tier: IPackageProgramTier) => () => {
    // package gắn với khách: chưa có customer thì mở popup chọn customer và không add
    if (!customer?.customerId) {
      dispatch(cashierActions.setVisibleChooseCustomer(true));
      return;
    }
    dispatch(cashierActions.selectPackageTierItem({ program, tier }));
  };

  if (loading && !programs.length) return <Spin />;

  return (
    <PackagesPanel>
      <div className='packages-scroll'>
        {selectedProgram ? (
          <>
            <PackageProgramChips programs={programs} selectedId={selectedProgram.id} onSelect={setSelectedProgramId} />
            <div className='program-section'>
              <PackageProgramHeader program={selectedProgram} />
              {tiers.length > 0 ? (
                <TierGrid>
                  {tiers.map((tier) => (
                    <PackageTierCard
                      key={tier.id}
                      tier={tier}
                      theme={getPackageThemeByType(tier.type)}
                      added={isPackageTierOnTicket(selectedItems, tier.id)}
                      onAddToTicket={handleAddToTicket(selectedProgram, tier)}
                    />
                  ))}
                </TierGrid>
              ) : <Empty />}
            </div>
          </>
        ) : <Empty />}
      </div>
    </PackagesPanel>
  );
};

export default ActivePackages;
